var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnmuteVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.652,
    viewBox: "0 0 24 21.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_197",
    "data-name": "Subtraction 197",
    d: "M20.914,21.652a.742.742,0,0,1-.53-.22l-3.119-3.119a2.918,2.918,0,0,1-2.71,1.867H2.9A2.9,2.9,0,0,1,0,17.28V5.08A2.9,2.9,0,0,1,1.494,2.543L.231,1.281A.75.75,0,0,1,1.292.22L2.958,1.886a.756.756,0,0,0,.085.1L21.527,20.471a.75.75,0,0,1-.613,1.181Zm1.174-4.591a1.865,1.865,0,0,1-1.055-.327l-3.578-2.462v.006L5.357,2.18h9.2a2.9,2.9,0,0,1,2.9,2.9V8.344l3.578-2.462a1.862,1.862,0,0,1,1.958-.094A1.98,1.98,0,0,1,24,7.524v7.568a1.977,1.977,0,0,1-1.008,1.735A1.866,1.866,0,0,1,22.088,17.061Z",
    fill: "#85888a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteVideo);
export default __webpack_public_path__ + "static/media/UnmuteVideo.f94663d80671cde6c44622b04e27b7fa.svg";
export { ForwardRef as ReactComponent };